"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extractCdnFromHeaders = extractCdnFromHeaders;
exports.getFileServedFromCdn = getFileServedFromCdn;
exports.getHeaders = getHeaders;
var CDN_LIST = {
  HIGHWINDS: {
    HEADER: 'X-HW',
    LABEL: 'HW'
  },
  CLOUDFRONT: {
    HEADER: 'X-Amz-Cf-Id',
    LABEL: 'CF'
  },
  LEVEL3: {
    HEADER: 'X-CDN',
    HEADER_VALUE: 'Level3',
    LABEL: 'L3'
  },
  UNKNOWN: {
    LABEL: 'UNKNOWN'
  }
};
var V3_M3U8_REGEX = /api\/v3.*?\.m3u8/m;
var V3_QUALITY_SUFFIX = '&quality=ld';
var V3_TS_REGEX = /^(http.*?.ts)$/m;
function getTsFileUrl(manifest) {
  var match = V3_TS_REGEX.exec(manifest) || [];
  if (match !== null && match.length > 0) {
    return Promise.resolve(match[0]);
  }
  return Promise.reject(null);
}
function getText(response) {
  return response.text();
}
function extractCdnFromHeaders(response) {
  var label = CDN_LIST.UNKNOWN.LABEL;
  for (var NAME in CDN_LIST) {
    if (CDN_LIST.hasOwnProperty(NAME)) {
      var cdn = CDN_LIST[NAME];
      if (cdn.HEADER_VALUE && response && response.headers.get(cdn.HEADER) === cdn.HEADER_VALUE) {
        label = cdn.LABEL;
      } else if (!cdn.HEADER_VALUE && response.headers.get(cdn.HEADER)) {
        label = cdn.LABEL;
      }
    }
  }
  return Promise.resolve(label);
}
function getHeaders(src) {
  return fetch(src, {
    method: 'HEAD'
  });
}
function getFileServedFromCdn(manifestUrl) {
  if (!V3_M3U8_REGEX.test(manifestUrl)) {
    return Promise.resolve(manifestUrl);
  }
  var hashIndex = manifestUrl.indexOf('#');
  var url = hashIndex > -1 ? manifestUrl.substring(0, manifestUrl.indexOf('#')) : manifestUrl;
  return fetch(url + V3_QUALITY_SUFFIX, {
    credentials: 'include'
  }).then(getText).then(getTsFileUrl);
}